export enum TopMenuPositionType {
  STANDARD = 1,
  HOME = 2,
  SAVED_REPORTS = 3
}
